import type { AskRevFilter } from '@/types/askRevFilters';

const FIELD_TO_TAB: Record<string, string> = {
	// metrics
	available_rooms: 'metrics',
	available_rooms_live: 'metrics',
	transient_cap: 'metrics',
	transient_capacity_live: 'metrics',
	total_fcst_incl_group: 'metrics',
	total_fcst_incl_group_live: 'metrics',
	current_otb: 'metrics',
	current_otb_live: 'metrics',
	adr: 'metrics',
	adr_live: 'metrics',
	revpar: 'metrics',
	revpar_live: 'metrics',
	occ_pct: 'metrics',
	occ_pct_live: 'metrics',
	fcst_occ_pct: 'metrics',
	fcst_occ_pct_live: 'metrics',

	// forecast
	event_count: 'forecast',
	transient_fcst: 'forecast',
	transient_fcst_event: 'forecast',
	unc_transient_fcst: 'forecast',
	a_fcst_sell: 'forecast',
	b_fcst_sell: 'forecast',
	c_fcst_sell: 'forecast',
	d_fcst_sell: 'forecast',
	e_fcst_sell: 'forecast',
	f_fcst_sell: 'forecast',
	g_fcst_sell: 'forecast',
	h_fcst_sell: 'forecast',

	// inventory
	current_otb_lyst: 'inventory',
	current_otb_lyf: 'inventory',
	group_blocked: 'inventory',
	group_blocked_live: 'inventory',
	group_booked: 'inventory',
	group_booked_live: 'inventory',
	out_of_order: 'inventory',
	ooo_live: 'inventory',
	total_capacity: 'inventory',
	overbooking: 'inventory',

	// pickup
	pkp_day_1: 'pickup',
	pkp_day_3: 'pickup',
	pkp_day_7: 'pickup',
	pkp_day_1_ly: 'pickup',
	pkp_day_3_ly: 'pickup',
	pkp_day_7_ly: 'pickup',
	pkp_doa_ly: 'pickup',
	transient_pkp_day_1: 'pickup',
	transient_pkp_day_3: 'pickup',
	transient_pkp_day_7: 'pickup',
	group_pkp_day_1: 'pickup',
	group_pkp_day_3: 'pickup',
	group_pkp_day_7: 'pickup',

	// rates
	last_current_rate: 'rates',
	prev_rec_rate: 'rates',
	rate_variance: 'rates',
	yoy_rate_lyst: 'rates',
	yoy_rate_lyf: 'rates',
	derived_rate: 'rates',
	conservative_rate: 'rates',
	neutral_rate: 'rates',
	aggressive_rate: 'rates',

	// kpi (fields exclusive to kpi or more specific here than metrics)
	adr_lyst: 'kpi',
	adr_lyf: 'kpi',
	revpar_lyst: 'kpi',
	revpar_lyf: 'kpi',
	occ_pct_lyst: 'kpi',
	occ_pct_lyf: 'kpi',
	fcst_rev: 'kpi',
	current_revenue: 'kpi',
	current_revenue_live: 'kpi',

	// competitors
	market_rate_lyf: 'competitors',
};

const TAB_DISPLAY_NAME: Record<string, string> = {
	metrics: 'My Metrics',
	forecast: 'Forecast',
	inventory: 'Inventory',
	pickup: 'Pickup',
	rates: 'Rates',
	competitors: 'Competitors',
	kpi: 'KPI',
};

export function getTabDisplayName(tabKey: string): string {
	return TAB_DISPLAY_NAME[tabKey] ?? tabKey;
}

export function resolveTabFromFields(
	filters: AskRevFilter[],
	sortBy?: string | null,
): string | null {
	const votes: Record<string, number> = {};

	const fields: string[] = filters.map((f) => f.field);
	if (sortBy) fields.push(sortBy);

	for (const field of fields) {
		if (field.startsWith('compRates.') || field.startsWith('compRate.')) {
			votes.competitors = (votes.competitors ?? 0) + 1;
			continue;
		}
		const tab = FIELD_TO_TAB[field];
		if (tab) {
			votes[tab] = (votes[tab] ?? 0) + 1;
		}
	}

	const entries = Object.entries(votes);
	if (entries.length === 0) return null;

	entries.sort((a, b) => b[1] - a[1]);
	const [topTab, topCount] = entries[0];
	if (entries.length > 1 && entries[1][1] === topCount) return null;

	return topTab;
}
